import styled from '@emotion/styled';
import { Box, TextareaAutosize } from '@mui/material';
import { WsColors, WsRadioObj, WsSelectObj } from 'wisestep-base';

export const StyledTextareaAutosize = styled(TextareaAutosize)(() => ({
  minWidth: '660px',
  backgroundColor: WsColors.White,
  minHeight: '20px',
  border: 'none',
  outline: '2px solid' + WsColors.TertiaryShades200,
  borderRadius: '5px',
}));

export const LayoutTheme = styled(Box)(() => ({
  maxWidth: '100%',
  maxHeight: 'xs',
  backgroundColor: WsColors.TertiaryShades50,
  padding: 2,
}));

export const mailProviderList: WsSelectObj[] = [
  { label: 'Elastic Email', value: 'elasticEmail' },
  { label: 'Amazon SES', value: 'amazonSES' },
  { label: 'Zimbra Server', value: 'zimbraServer' },
];

export const parserServiceList: WsSelectObj[] = [
  { label: 'Wisestep Parser', value: 'wisestepParser' },
  { label: 'Rchilli Parser', value: 'rchilliParser' },
  { label: 'CPP', value: 'cpp' },
];

export const visibilityOptions: WsRadioObj[] = [
  {
    value: 'discoverable',
    label: 'Discoverable',
  },
  {
    value: 'private',
    label: 'Private',
  },
];

export const autoJoinOptions: WsRadioObj[] = [
  {
    value: 'Yes',
    label: 'Yes',
  },
  {
    value: 'No',
    label: 'No',
  },
];

export const multiLoginOptions: WsRadioObj[] = [
  {
    value: 'Yes',
    label: 'Yes',
  },
  {
    value: 'No',
    label: 'No',
  },
];
